import { createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
/**
 * @author xiezhixiong
 * @fileoverview 冠军赛总决赛对战图
 */
import { defineComponent, ref, onMounted, onBeforeUnmount, inject } from "vue";
import useRespondTo from "@/hooks/common/respond-to";
import { homePageContextKey } from "@/context/home-page";
import { championshipPC } from "@/config/homePage";
import WarSchedule from "../../common/war-schedule";
import { averageGroup, battleTeamNum } from "./utils";
export default defineComponent({
  name: "BattleMap16",
  props: {
    zone1Teams: {
      type: Array,
      default() {
        return [];
      }
    },
    zone2Teams: {
      type: Array,
      default() {
        return [];
      }
    },
    // 组别
    groupType: {
      type: Number,
      default: 1
    }
  },
  emits: ["select"],
  setup(props, {
    emit
  }) {
    // const zone1Teams = ref([
    //   [
    //     {
    //       id: 1,
    //       // winner: 3,
    //       redTeam: {
    //         name: '测试3队',
    //         teamId: 3,
    //         wins: 2,
    //       },
    //       blueTeam: {
    //         name: '测试12队',
    //         teamId: 3,
    //         wins: 2,
    //       },
    //     },
    //   ],
    // ]);
    const raceScale = ref(0);
    const {
      isMobile
    } = useRespondTo();
    const {
      homePageState
    } = inject(homePageContextKey);
    const resizeListener = () => {
      const innerWidth = window.innerWidth;
      // 赛事图原本大小 131，在 375 宽度的屏幕下，显示为 72 ，
      // 求当前屏幕宽度的缩放比
      raceScale.value = 72 * innerWidth / 375 / 134;
    };
    resizeListener();
    const attachResizeListener = () => {
      window.addEventListener("resize", resizeListener);
    };
    const detachResizeListener = () => {
      window.removeEventListener("resize", resizeListener);
    };
    onMounted(() => {
      attachResizeListener();
    });
    onBeforeUnmount(() => {
      detachResizeListener();
    });
    const handleSelect = record => {
      if (!record) {
        return;
      }
      emit("select", record);
    };
    const battleResult = battle => {
      var _battle$redTeam;
      const res = {
        winner: null,
        loser: null
      };
      if (!battle.winner) {
        return res;
      }
      if (battle.winner === ((_battle$redTeam = battle.redTeam) === null || _battle$redTeam === void 0 ? void 0 : _battle$redTeam.teamId)) {
        res.winner = battle.redTeam;
        res.loser = battle.blueTeam;
      } else {
        res.winner = battle.blueTeam;
        res.loser = battle.redTeam;
      }
      return res;
    };
    return () => {
      var _firstVal$, _firstVal$2, _thirdPlace$redTeam, _thirdPlaceRes$winner, _thirdPlace$blueTeam, _thirdPlaceRes$winner2, _lastBattle$blueTeam, _lastBattleRes$winner, _lastBattle$redTeam, _lastBattleRes$winner2, _championshipPC$homeP, _championshipPC$homeP2, _championshipPC$homeP3, _championshipPC$homeP4, _championshipPC$homeP5, _championshipPC$homeP6, _preliminaries1$, _preliminaries2$;
      const [firstVal, secondVal] = averageGroup(props.zone1Teams);
      // 预赛 1
      const preliminaries1 = firstVal === null || firstVal === void 0 ? void 0 : firstVal.slice(0, 1);
      // 预赛 2
      const preliminaries2 = secondVal === null || secondVal === void 0 ? void 0 : secondVal.slice(0, 1);

      // 决赛数据
      const lastBattle = (firstVal === null || firstVal === void 0 ? void 0 : (_firstVal$ = firstVal[2]) === null || _firstVal$ === void 0 ? void 0 : _firstVal$[0]) || {};
      const lastBattleRes = battleResult(lastBattle);

      // 季军赛数据
      const thirdPlace = (firstVal === null || firstVal === void 0 ? void 0 : (_firstVal$2 = firstVal[1]) === null || _firstVal$2 === void 0 ? void 0 : _firstVal$2[0]) || {};
      const thirdPlaceRes = battleResult(thirdPlace);

      // 第一名
      const champion = lastBattleRes.winner;
      let teamsArrPro = [{
        teamInfo: thirdPlace === null || thirdPlace === void 0 ? void 0 : thirdPlace.redTeam,
        // 队伍信息
        ended: !!thirdPlaceRes.winner,
        // 是否对战结束
        victoryTeamId: thirdPlace.winner,
        //胜者ID
        ranking: (thirdPlace === null || thirdPlace === void 0 ? void 0 : (_thirdPlace$redTeam = thirdPlace.redTeam) === null || _thirdPlace$redTeam === void 0 ? void 0 : _thirdPlace$redTeam.teamId) === ((_thirdPlaceRes$winner = thirdPlaceRes.winner) === null || _thirdPlaceRes$winner === void 0 ? void 0 : _thirdPlaceRes$winner.teamId) ? 3 : 4 // 排名
      }, {
        teamInfo: thirdPlace === null || thirdPlace === void 0 ? void 0 : thirdPlace.blueTeam,
        ended: !!thirdPlaceRes.winner,
        // 是否对战结束
        victoryTeamId: thirdPlace.winner,
        //胜者ID
        ranking: (thirdPlace === null || thirdPlace === void 0 ? void 0 : (_thirdPlace$blueTeam = thirdPlace.blueTeam) === null || _thirdPlace$blueTeam === void 0 ? void 0 : _thirdPlace$blueTeam.teamId) === ((_thirdPlaceRes$winner2 = thirdPlaceRes.winner) === null || _thirdPlaceRes$winner2 === void 0 ? void 0 : _thirdPlaceRes$winner2.teamId) ? 3 : 4
      }, {
        teamInfo: lastBattle === null || lastBattle === void 0 ? void 0 : lastBattle.blueTeam,
        ended: !!lastBattleRes.winner,
        // 是否对战结束
        victoryTeamId: lastBattle.winner,
        //胜者ID
        ranking: (lastBattle === null || lastBattle === void 0 ? void 0 : (_lastBattle$blueTeam = lastBattle.blueTeam) === null || _lastBattle$blueTeam === void 0 ? void 0 : _lastBattle$blueTeam.teamId) === ((_lastBattleRes$winner = lastBattleRes.winner) === null || _lastBattleRes$winner === void 0 ? void 0 : _lastBattleRes$winner.teamId) ? 1 : 2 // 排名
      }, {
        teamInfo: lastBattle === null || lastBattle === void 0 ? void 0 : lastBattle.redTeam,
        ended: !!lastBattleRes.winner,
        // 是否对战结束
        victoryTeamId: lastBattle.winner,
        //胜者ID
        ranking: (lastBattle === null || lastBattle === void 0 ? void 0 : (_lastBattle$redTeam = lastBattle.redTeam) === null || _lastBattle$redTeam === void 0 ? void 0 : _lastBattle$redTeam.teamId) === ((_lastBattleRes$winner2 = lastBattleRes.winner) === null || _lastBattleRes$winner2 === void 0 ? void 0 : _lastBattleRes$winner2.teamId) ? 1 : 2
      }];
      console.log("teamsArrPro:", firstVal);
      // 决赛时间
      const championDate = (_championshipPC$homeP = championshipPC[homePageState.raceQuartertype][2]) === null || _championshipPC$homeP === void 0 ? void 0 : (_championshipPC$homeP2 = _championshipPC$homeP.fullDateText) === null || _championshipPC$homeP2 === void 0 ? void 0 : _championshipPC$homeP2[props.groupType - 1];
      //季军赛时间
      const jjDate = (_championshipPC$homeP3 = championshipPC[homePageState.raceQuartertype][2]) === null || _championshipPC$homeP3 === void 0 ? void 0 : (_championshipPC$homeP4 = _championshipPC$homeP3.jjDateText) === null || _championshipPC$homeP4 === void 0 ? void 0 : _championshipPC$homeP4[props.groupType - 1];
      //四强赛时间
      const sqDate = (_championshipPC$homeP5 = championshipPC[homePageState.raceQuartertype][2]) === null || _championshipPC$homeP5 === void 0 ? void 0 : (_championshipPC$homeP6 = _championshipPC$homeP5.sqDateText) === null || _championshipPC$homeP6 === void 0 ? void 0 : _championshipPC$homeP6[props.groupType - 1];
      const battle1 = preliminaries1 === null || preliminaries1 === void 0 ? void 0 : (_preliminaries1$ = preliminaries1[0]) === null || _preliminaries1$ === void 0 ? void 0 : _preliminaries1$[0];
      const battle2 = preliminaries2 === null || preliminaries2 === void 0 ? void 0 : (_preliminaries2$ = preliminaries2[0]) === null || _preliminaries2$ === void 0 ? void 0 : _preliminaries2$[0];
      if (isMobile.value) {
        var _thirdPlace$blueTeam2, _thirdPlaceRes$winner3, _thirdPlace$redTeam2, _thirdPlaceRes$winner4, _lastBattle$blueTeam2, _lastBattleRes$winner3, _lastBattle$redTeam2, _lastBattleRes$winner4;
        teamsArrPro = [{
          teamInfo: thirdPlace === null || thirdPlace === void 0 ? void 0 : thirdPlace.blueTeam,
          ended: !!thirdPlaceRes.winner,
          // 是否对战结束
          victoryTeamId: thirdPlace.winner,
          //胜者ID
          ranking: (thirdPlace === null || thirdPlace === void 0 ? void 0 : (_thirdPlace$blueTeam2 = thirdPlace.blueTeam) === null || _thirdPlace$blueTeam2 === void 0 ? void 0 : _thirdPlace$blueTeam2.teamId) === ((_thirdPlaceRes$winner3 = thirdPlaceRes.winner) === null || _thirdPlaceRes$winner3 === void 0 ? void 0 : _thirdPlaceRes$winner3.teamId) ? 3 : 4
        }, {
          teamInfo: thirdPlace === null || thirdPlace === void 0 ? void 0 : thirdPlace.redTeam,
          // 队伍信息
          ended: !!thirdPlaceRes.winner,
          // 是否对战结束
          victoryTeamId: thirdPlace.winner,
          //胜者ID
          ranking: (thirdPlace === null || thirdPlace === void 0 ? void 0 : (_thirdPlace$redTeam2 = thirdPlace.redTeam) === null || _thirdPlace$redTeam2 === void 0 ? void 0 : _thirdPlace$redTeam2.teamId) === ((_thirdPlaceRes$winner4 = thirdPlaceRes.winner) === null || _thirdPlaceRes$winner4 === void 0 ? void 0 : _thirdPlaceRes$winner4.teamId) ? 3 : 4 // 排名
        }, {
          teamInfo: lastBattle === null || lastBattle === void 0 ? void 0 : lastBattle.blueTeam,
          ended: !!lastBattleRes.winner,
          // 是否对战结束
          victoryTeamId: lastBattle.winner,
          //胜者ID
          ranking: (lastBattle === null || lastBattle === void 0 ? void 0 : (_lastBattle$blueTeam2 = lastBattle.blueTeam) === null || _lastBattle$blueTeam2 === void 0 ? void 0 : _lastBattle$blueTeam2.teamId) === ((_lastBattleRes$winner3 = lastBattleRes.winner) === null || _lastBattleRes$winner3 === void 0 ? void 0 : _lastBattleRes$winner3.teamId) ? 1 : 2 // 排名
        }, {
          teamInfo: lastBattle === null || lastBattle === void 0 ? void 0 : lastBattle.redTeam,
          ended: !!lastBattleRes.winner,
          // 是否对战结束
          victoryTeamId: lastBattle.winner,
          //胜者ID
          ranking: (lastBattle === null || lastBattle === void 0 ? void 0 : (_lastBattle$redTeam2 = lastBattle.redTeam) === null || _lastBattle$redTeam2 === void 0 ? void 0 : _lastBattle$redTeam2.teamId) === ((_lastBattleRes$winner4 = lastBattleRes.winner) === null || _lastBattleRes$winner4 === void 0 ? void 0 : _lastBattleRes$winner4.teamId) ? 1 : 2
        }];
        return _createVNode("div", {
          "class": "battle-map-m"
        }, [_createVNode("div", {
          "class": "battle-map-m-race"
        }, [_createVNode("div", {
          "class": "battle-map-m-awarding"
        }, [_createVNode("div", {
          "class": "battle-map-m-awarding-promotion battle-map-m-awarding-promotion-top"
        }, [_createVNode("div", {
          "class": "battle-map-m-awarding-promotion-content"
        }, [_createVNode("strong", null, [_createTextVNode("\u5B63\u519B\u8D5B")]), _createVNode("span", null, [jjDate])])]), _createVNode("div", {
          "class": "battle-map-m-awarding-promotion battle-map-m-awarding-promotion-bottom"
        }, [_createVNode("div", {
          "class": "battle-map-m-awarding-promotion-content"
        }, [_createVNode("strong", null, [_createTextVNode("\u51B3\u8D5B")]), _createVNode("span", null, [championDate])])]), _createVNode("div", {
          "class": "battle-map-m-awarding-platform"
        }, [teamsArrPro.map((item, index) => {
          var _item$teamInfo, _item$teamInfo2;
          return _createVNode("div", {
            "key": index,
            "class": `battle-map-m-awarding-platform-${index + 1}`
          }, [_createVNode("div", {
            "class": ["battle-map-m-awarding-platform-container", index === 0 || index === 1 ? "battle-map-m-awarding-platform-container-loser" : "battle-map-m-awarding-platform-container-winner"],
            "onClick": () => handleSelect(item === null || item === void 0 ? void 0 : item.teamInfo)
          }, [(item === null || item === void 0 ? void 0 : item.ended) && // <img
          //   class="battle-map-m-awarding-platform-title"
          //   src={require(`@/assets/img/championship/pc/title-${item?.ranking}.png`)}
          // />
          _createVNode("img", {
            "class": ["battle-map-m-awarding-platform-title", item.ranking === 4 ? "battle-map-m-awarding-platform__hide" : ""],
            "src": require(`@/assets/img/championship/pc/title-${item === null || item === void 0 ? void 0 : item.ranking}.png`)
          }, null), (item === null || item === void 0 ? void 0 : item.teamInfo) && _createVNode("div", {
            "class": ["battle-map-awarding-platform-team", item.victoryTeamId === item.teamInfo.teamId ? "battle-map-awarding-platform-team-red" : "battle-map-awarding-platform-team-blue", "battle-map-m-awarding-platform-team"]
          }, [_createVNode("div", {
            "class": "battle-map-awarding-platform-team-content battle-map-m-awarding-platform-team-content"
          }, [_createVNode("span", {
            "class": "battle-map-awarding-platform-team-name battle-map-m-awarding-platform-team-name"
          }, [item === null || item === void 0 ? void 0 : (_item$teamInfo = item.teamInfo) === null || _item$teamInfo === void 0 ? void 0 : _item$teamInfo.name]), _createVNode("span", {
            "class": "battle-map-awarding-platform-team-score battle-map-m-awarding-platform-team-score"
          }, [item === null || item === void 0 ? void 0 : (_item$teamInfo2 = item.teamInfo) === null || _item$teamInfo2 === void 0 ? void 0 : _item$teamInfo2.wins])])])])]);
        })]), _createVNode("div", {
          "class": "battle-map-m-awarding-platform-chessboard battle-map-m-awarding-platform-chessboard-1"
        }, [_createVNode("div", {
          "class": ["battle-map-awarding-platform-team", "battle-map-awarding-platform-team-red", "battle-map-m-awarding-platform-team", "battle-map-m-awarding-platform-battle-red"],
          "onClick": () => handleSelect(battle1 === null || battle1 === void 0 ? void 0 : battle1.redTeam)
        }, [_createVNode("div", {
          "class": "battle-map-awarding-platform-team-content battle-map-m-awarding-platform-team-content"
        }, [_createVNode("span", {
          "class": "battle-map-awarding-platform-team-name battle-map-m-awarding-platform-team-name"
        }, [battle1 === null || battle1 === void 0 ? void 0 : battle1.redTeam.name]), _createVNode("span", {
          "class": "battle-map-awarding-platform-team-score battle-map-m-awarding-platform-team-score"
        }, [battle1 === null || battle1 === void 0 ? void 0 : battle1.redTeam.wins])])]), _createVNode("div", {
          "class": ["battle-map-awarding-platform-team", "battle-map-awarding-platform-team-red", "battle-map-m-awarding-platform-team", "battle-map-m-awarding-platform-battle-blue"],
          "onClick": () => handleSelect(battle1 === null || battle1 === void 0 ? void 0 : battle1.blueTeam)
        }, [_createVNode("div", {
          "class": "battle-map-awarding-platform-team-content battle-map-m-awarding-platform-team-content"
        }, [_createVNode("span", {
          "class": "battle-map-awarding-platform-team-name battle-map-m-awarding-platform-team-name"
        }, [battle1 === null || battle1 === void 0 ? void 0 : battle1.blueTeam.name]), _createVNode("span", {
          "class": "battle-map-awarding-platform-team-score battle-map-m-awarding-platform-team-score"
        }, [battle1 === null || battle1 === void 0 ? void 0 : battle1.blueTeam.wins])])]), _createVNode("span", {
          "class": "battle-map-m-awarding-platform-date"
        }, [sqDate])]), _createVNode("div", {
          "class": "battle-map-m-awarding-platform-chessboard battle-map-m-awarding-platform-chessboard-2"
        }, [_createVNode("div", {
          "class": ["battle-map-awarding-platform-team", "battle-map-awarding-platform-team-red", "battle-map-m-awarding-platform-team", "battle-map-m-awarding-platform-battle-red"],
          "onClick": () => handleSelect(battle2 === null || battle2 === void 0 ? void 0 : battle2.redTeam)
        }, [_createVNode("div", {
          "class": "battle-map-awarding-platform-team-content battle-map-m-awarding-platform-team-content"
        }, [_createVNode("span", {
          "class": "battle-map-awarding-platform-team-name battle-map-m-awarding-platform-team-name"
        }, [battle2 === null || battle2 === void 0 ? void 0 : battle2.redTeam.name]), _createVNode("span", {
          "class": "battle-map-awarding-platform-team-score battle-map-m-awarding-platform-team-score"
        }, [battle2 === null || battle2 === void 0 ? void 0 : battle2.redTeam.wins])])]), _createVNode("div", {
          "class": ["battle-map-awarding-platform-team", "battle-map-awarding-platform-team-red", "battle-map-m-awarding-platform-team", "battle-map-m-awarding-platform-battle-blue"],
          "onClick": () => handleSelect(battle2 === null || battle2 === void 0 ? void 0 : battle2.blueTeam)
        }, [_createVNode("div", {
          "class": "battle-map-awarding-platform-team-content battle-map-m-awarding-platform-team-content"
        }, [_createVNode("span", {
          "class": "battle-map-awarding-platform-team-name battle-map-m-awarding-platform-team-name"
        }, [battle2 === null || battle2 === void 0 ? void 0 : battle2.blueTeam.name]), _createVNode("span", {
          "class": "battle-map-awarding-platform-team-score battle-map-m-awarding-platform-team-score"
        }, [battle2 === null || battle2 === void 0 ? void 0 : battle2.blueTeam.wins])])]), _createVNode("span", {
          "class": "battle-map-m-awarding-platform-date"
        }, [sqDate])])])])]);
      }
      return _createVNode("div", {
        "class": "battle-map"
      }, [_createVNode("div", {
        "class": "battle-map-race"
      }, [_createVNode("div", {
        "class": "battle-map-list"
      }, [_createVNode("div", {
        "class": "battle-map-list-item"
      }, [_createVNode(WarSchedule, {
        "teams": preliminaries1,
        "teamNum": battleTeamNum(preliminaries1),
        "gridHeight": 62,
        "height": "210px",
        "offset": {
          top: 136,
          left: 28
        },
        "stroke": false,
        "onSelect": handleSelect
      }, null)]), _createVNode("div", {
        "class": "battle-map-list-item"
      }, [_createVNode(WarSchedule, {
        "teams": preliminaries2,
        "teamNum": battleTeamNum(preliminaries2),
        "gridHeight": 62,
        "height": "210px",
        "offset": {
          top: 135,
          left: 274
        },
        "onSelect": handleSelect,
        "reverse": true
      }, null)])]), _createVNode("div", {
        "class": "battle-map-promotion"
      }, [_createVNode("img", {
        "class": "battle-map-promotion-medal",
        "src": require(`@/assets/img/championship/pc/medal${homePageState.raceQuartertype}.png`)
      }, null), _createVNode("span", {
        "class": "battle-map-promotion-txt"
      }, [(champion === null || champion === void 0 ? void 0 : champion.name) || "冠军战队"]), _createVNode("div", {
        "class": "battle-map-promotion-arrow"
      }, null)]), _createVNode("div", {
        "class": "battle-map-awarding"
      }, [_createVNode("span", {
        "class": "battle-map-awarding-date battle-map-awarding-date__left"
      }, [sqDate]), _createVNode("span", {
        "class": "battle-map-awarding-date battle-map-awarding-date__right"
      }, [sqDate]), _createVNode("div", {
        "class": "battle-map-awarding-promotion battle-map-awarding-promotion-top"
      }, [_createVNode("div", {
        "class": "battle-map-awarding-promotion-content"
      }, [_createVNode("strong", null, [_createTextVNode("\u5B63\u519B\u8D5B")]), _createVNode("span", null, [jjDate])])]), _createVNode("div", {
        "class": "battle-map-awarding-promotion battle-map-awarding-promotion-bottom"
      }, [_createVNode("div", {
        "class": "battle-map-awarding-promotion-content"
      }, [_createVNode("strong", null, [_createTextVNode("\u51B3\u8D5B")]), _createVNode("span", null, [championDate])])]), _createVNode("div", {
        "class": "battle-map-awarding-platform"
      }, [teamsArrPro.map((item, index) => {
        var _item$teamInfo3, _item$teamInfo4;
        return _createVNode("div", {
          "key": index,
          "class": `battle-map-awarding-platform-${index + 1}`
        }, [_createVNode("div", {
          "class": ["battle-map-awarding-platform-container", index === 0 || index === 1 ? "battle-map-awarding-platform-container-loser" : "battle-map-awarding-platform-container-winner"],
          "onClick": () => handleSelect(item === null || item === void 0 ? void 0 : item.teamInfo)
        }, [(item === null || item === void 0 ? void 0 : item.ended) && _createVNode("img", {
          "class": ["battle-map-awarding-platform-title", item.ranking === 4 ? "battle-map-awarding-platform-title__hide" : "", index === 1 || index === 3 ? "battle-map-awarding-platform-title__right" : ""],
          "src": require(`@/assets/img/championship/pc/title-${item === null || item === void 0 ? void 0 : item.ranking}.png`)
        }, null), (item === null || item === void 0 ? void 0 : item.teamInfo) && _createVNode("div", {
          "class": ["battle-map-awarding-platform-team", (index === 1 || index === 3) && (item.victoryTeamId === item.teamInfo.teamId || !item.victoryTeamId) ? "battle-map-awarding-platform-team-red__reverse" : "", (index === 1 || index === 3) && item.victoryTeamId && item.victoryTeamId !== item.teamInfo.teamId ? "battle-map-awarding-platform-team-blue__reverse" : "", item.victoryTeamId === item.teamInfo.teamId || !item.victoryTeamId ? "battle-map-awarding-platform-team-red" : "battle-map-awarding-platform-team-blue"]
        }, [_createVNode("div", {
          "class": "battle-map-awarding-platform-team-content"
        }, [_createVNode("span", {
          "class": "battle-map-awarding-platform-team-name",
          "style": {
            order: index === 1 || index === 3 ? 2 : 1,
            marginLeft: index === 1 || index === 3 ? "0px" : "4px",
            marginRight: index === 1 || index === 3 ? "4px" : "0"
          }
        }, [item === null || item === void 0 ? void 0 : (_item$teamInfo3 = item.teamInfo) === null || _item$teamInfo3 === void 0 ? void 0 : _item$teamInfo3.name]), _createVNode("span", {
          "class": "battle-map-awarding-platform-team-score",
          "style": {
            order: index === 1 || index === 3 ? 1 : 2,
            left: index === 1 || index === 3 ? "1px" : "-1px"
          }
        }, [item === null || item === void 0 ? void 0 : (_item$teamInfo4 = item.teamInfo) === null || _item$teamInfo4 === void 0 ? void 0 : _item$teamInfo4.wins])])])])]);
      })])])])]);
    };
  }
});